
import "C:/GIT/CODE/dartsCloud/web/darts/src/components/TeamDropdown/index.less?modules";
export default {"teamItem": `teamItem-yCTYI6r0`,"teamIcon": `teamIcon-Tuq97FDb`,"teamName": `teamName-9BwelWjE`,"teamRow": `teamRow-Zc9X-xjW`,"manageLink": `manageLink-UChxSi51`,"dropdownOverlay": `dropdownOverlay-G1sUYS-3`}
